import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import memberRouter from "./memberRouter";
import ProtectedRoute from "./ProtectedRoute";

const Loading = (
  <div className="w-full h-[100dvh] flex items-center justify-center bg-gradient-to-b from-slate-900 via-blue-900 to-cyan-700 bg-fixed">
    <p className="text-sm text-white/70">Loading...</p>
  </div>
);
const LoginPage = lazy(() => import("../pages/LoginPage"));
const Main = lazy(() => import("../pages/MainPage"));
const Attendance = lazy(() => import("../pages/attendance/AttendancePage"));
const AttendanceRank = lazy(() =>
  import("../pages/attendance/AttendanceRankPage")
);
const Notice = lazy(() => import("../pages/notice/NoticePage"));
const NoticeDetail = lazy(() => import("../pages/notice/NoticeDetailPage"));
const Calendar = lazy(() => import("../pages/calendar/CalendarPage"));
const Secondhand = lazy(() => import("../pages/secondhand/SecondhandPage"));
const SecondhandDetail = lazy(() =>
  import("../pages/secondhand/SecondhandDetailPage")
);
const SecondhandWrite = lazy(() =>
  import("../pages/secondhand/SecondhandWritePage")
);
const Gallery = lazy(() => import("../pages/gallery/GalleryPage"));
const SeasonRoom = lazy(() => import("../pages/seasonRoom/SeasonRoomPage"));
const SeasonRoomDetail = lazy(() =>
  import("../pages/seasonRoom/SeasonRoomDetailPage")
);
const SeasonRoomWrite = lazy(() =>
  import("../pages/seasonRoom/SeasonRoomWritePage")
);

const root = createBrowserRouter([
  // 공개 라우트: 메인, 로그인, 카카오 콜백/가입 플로우
  {
    path: "",
    element: (
      <Suspense fallback={Loading}>
        <Main />
      </Suspense>
    ),
  },
  {
    path: "login",
    element: (
      <Suspense fallback={Loading}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: "notice", // 공지 목록은 비로그인 사용자도 조회 가능
    element: (
      <Suspense fallback={Loading}>
        <Notice />
      </Suspense>
    ),
  },
  { path: "member", children: memberRouter() },
  // 보호 라우트: ProtectedRoute 가 비로그인 시 /login 으로 리다이렉트
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "attendance",
        children: [
          {
            index: true, // /attendance
            element: (
              <Suspense fallback={Loading}>
                <Attendance />
              </Suspense>
            ),
          },
          {
            path: "rank", // /attendance/rank
            element: (
              <Suspense fallback={Loading}>
                <AttendanceRank />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "notice/:noticePk", // 공지 상세는 로그인 사용자만 조회 가능
        element: (
          <Suspense fallback={Loading}>
            <NoticeDetail />
          </Suspense>
        ),
      },
      {
        path: "calendar", // /calendar
        element: (
          <Suspense fallback={Loading}>
            <Calendar />
          </Suspense>
        ),
      },
      {
        path: "gallery", // /gallery
        element: (
          <Suspense fallback={Loading}>
            <Gallery />
          </Suspense>
        ),
      },
      {
        path: "secondhand",
        children: [
          {
            index: true, // /secondhand
            element: (
              <Suspense fallback={Loading}>
                <Secondhand />
              </Suspense>
            ),
          },
          {
            path: "new", // /secondhand/new
            element: (
              <Suspense fallback={Loading}>
                <SecondhandWrite />
              </Suspense>
            ),
          },
          {
            path: ":postPk", // /secondhand/:postPk
            element: (
              <Suspense fallback={Loading}>
                <SecondhandDetail />
              </Suspense>
            ),
          },
          {
            path: ":postPk/edit", // /secondhand/:postPk/edit
            element: (
              <Suspense fallback={Loading}>
                <SecondhandWrite />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "season-room",
        children: [
          {
            index: true, // /season-room
            element: (
              <Suspense fallback={Loading}>
                <SeasonRoom />
              </Suspense>
            ),
          },
          {
            path: "new", // /season-room/new
            element: (
              <Suspense fallback={Loading}>
                <SeasonRoomWrite />
              </Suspense>
            ),
          },
          {
            path: ":postPk", // /season-room/:postPk
            element: (
              <Suspense fallback={Loading}>
                <SeasonRoomDetail />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
]);

export default root;
